<span class="filter-chip">
    <span class="chip-label">{{ label }}</span>
    <button type="button" class="chip-close" (click)="onRemove()" aria-label="Remove filter">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
</span>
